import { useState } from "react";

const navItems = [
  { href: "#today", label: "今日更新" },
  { href: "#reminder", label: "更新提醒" },
  { href: "#calendar", label: "追更日历" },
  { href: "#feed", label: "快讯流" },
  { href: "#comments", label: "热评区" },
  { href: "#faq", label: "常见问题" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/70 bg-background-50/92 backdrop-blur">
      <div className="flex h-16 w-full items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 font-heading text-lg font-bold text-background-50">
            黑
          </span>
          <span className="flex flex-col leading-none">
            <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              黑料每日
            </h1>
            <span className="mt-1 text-[11px] text-foreground-500">
              每日更新节奏 · 蹲更新不迷路
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <span className="hidden items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 xl:flex">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-checkbox-circle-fill"></i>
            </span>
            今日已更新 3/6
          </span>
          <a
            href="#reminder"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex dark:text-foreground-950"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-notification-3-line"></i>
            </span>
            开启更新提醒
          </a>
          <button
            type="button"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
            aria-label="打开导航"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer whitespace-nowrap rounded-md bg-background-100 px-3 py-2.5 text-center text-sm text-foreground-800"
              >
                {item.label}
              </a>
            ))}
          </div>
          <a
            href="#reminder"
            onClick={() => setOpen(false)}
            className="mt-2 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-notification-3-line"></i>
            </span>
            开启更新提醒
          </a>
        </div>
      )}
    </header>
  );
}